import { render } from "./AIAgentsComponent.vue?vue&type=template&id=38df95c0"
import script from "./AIAgentsComponent.vue?vue&type=script&lang=js"
export * from "./AIAgentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__